import { useTranslation } from 'react-i18next';
import GenericModal from '~/components/common/GenericModal';
import type { CoreOfficeDataType } from '~/types/offices';
import RequestVisitComponent from './RequestVisitComponent';
import { Button } from '~/components/common/buttons/Button';
import { useRef } from 'react';
import type { HostDataType } from '~/types/userTypes';
import mixpanelTrack from '~/hooks/useMixPanel';
import { useUser } from '~/modules/useUser';

declare var bootstrap: any;

type TProps = {
  office: CoreOfficeDataType;
  hostData: HostDataType;
};

const BottomBar = ({ office, hostData }: TProps) => {
  const { t } = useTranslation();
  const clientStore = useUser();
  const modalRef = useRef<HTMLDivElement>(null);

  const openModal = () => {
    if (modalRef.current) {
      const modal = bootstrap?.Modal.getOrCreateInstance(modalRef.current);
      modal?.show();
    }
  };

  return (
    <>
      <div className="request-visit-bottom-bar position-fixed bottom-0 start-0 d-md-none bg-white w-100 py-2 px-4 z-2">
        <div className="d-flex gap-2 justify-content-between align-items-center">
          <Button
            disabled={clientStore?.isHost || office.publicationState === 'unpublished'}
            extraClasses="w-100"
            variant="accent"
            size="lg"
            onClick={() => {
              mixpanelTrack('E.mobile_bb_visit_intent');
              openModal();
            }}
          >
            <span className="text-1 -medium">{t('office.show.bottomBar.submitBtn')}</span>
          </Button>
        </div>
      </div>

      <GenericModal
        modalRef={modalRef}
        open={true}
        title={t('office.show.requestVisitCard.title').toString()}
        animate={false}
        id="ctaCardModal"
      >
        <div className="modal-body">
          <RequestVisitComponent
            office={office}
            hostData={hostData}
          />
        </div>
      </GenericModal>
    </>
  );
};

export default BottomBar;
